import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { LayoutGrid, Search, Settings, Wallet, } from 'lucide-react';
import { images } from '../utilities/img';

import { useDispatch, useSelector } from 'react-redux';

// states_g
import { openSidebar, closeSidebar } from './../redux/sidebarSlice';
import { closeRightbar, openRightbar } from '../redux/rightbarSlice';


const NavBar = () => {

    const showsidebar = useSelector((state) => state.showsidebar.value)
    const showrightbar = useSelector((state) => state.showrightbar.value)
    const dispatch = useDispatch()

    const windowscrollvalue = window.scrollY
    const [showmobilenav, setshowmobilenav] = useState(null)
    const [windowWidth, setWindowWidth] = useState(window.innerWidth)

    useEffect(() => {
        const handleResize = () => {
            setWindowWidth(window.innerWidth);
            console.log(window.innerWidth)
        };

        const handleScroll = () => {
            // console.log(window.scrollY)
            setshowmobilenav(null)
        }

        window.addEventListener('resize', handleResize);

        window.addEventListener('scroll', handleScroll);

        // Cleanup: Remove the event listener when the component is unmounted
        return () => {
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('scroll', handleScroll)
        };
    }, []);

    const handleMobilenav = () => {
        if(!showmobilenav) {
            setshowmobilenav(true)
        } else {
            setshowmobilenav(false)
        }
    }

    const handleShowsidebar = () => { 
        if(windowWidth < 900) {
            dispatch(closeRightbar())
            if(showsidebar) {
                dispatch(closeSidebar())
            } else {
                dispatch(openSidebar())
            }
        }
    }

    const handleShowrightbar = () => {
        if (windowWidth < 900) {
          dispatch(closeSidebar());
          if (showrightbar) {
            dispatch(closeRightbar());
            console.log("rightbar status: ", showrightbar)
        } else {
            dispatch(openRightbar());
            console.log("rightbar status: ", showrightbar)
          }
        }
    };



    return ( 
        <>
            <header>
                <div className="nav-header-inner flex row justify-space-between align-center">
                    
                    <div className="flex row gap-10 align-center">
                        {windowWidth < 900 ? <div className="grid-icon flex justify-center align-center cursor-pointer" onClick={handleShowsidebar}>
                            <LayoutGrid size={15} color='var(--d-white)' />
                        </div> : null}

                        <div className="flex row gap-10 align-center nav-logo">
                            <img src={images.general.eva_logo_green} alt="" />
                            <h2 className="lg_bold d-white_c text-transform-uppercase">EVALYS</h2>
                        </div>
                    </div>

                    {/* <div className="search-input flex row align-center gap-10">
                        <Search size={20} color='var(--d-white)' />
                        <input type="text" placeholder='Search' className='d-white_c hn_medium' />
                    </div> */}

                    <div className="nav-action-btns flex row align-center gap-10">

                        {/* <div className="nav-action-btn flex row align-center gap-10">
                            <p className='d-white_c hn_medium text-transform-uppercase'>solana mainnet</p>    
                        </div> */}

                        {windowWidth < 900 ? <div className="grid-icon flex justify-center align-center cursor-pointer" onClick={handleShowrightbar}>
                            <Settings size={15} color='var(--d-white)' />
                        </div> : null}

                        <div className="nav-action-btn flex row align-center gap-10 cursor-pointer active">
                            <p className='d-white_c hn_medium text-transform-uppercase'>connect</p>    
                            <Wallet size={windowWidth < 900 ? 15 : 20} color='var(--d-white)' />
                        </div>

                    </div>

                </div>
            </header>

        </>
    );
}
 
export default NavBar;